var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0H14.25V9H0.75V0ZM7.5 2.25C8.09674 2.25 8.66903 2.48705 9.09099 2.90901C9.51295 3.33097 9.75 3.90326 9.75 4.5C9.75 5.09674 9.51295 5.66903 9.09099 6.09099C8.66903 6.51295 8.09674 6.75 7.5 6.75C6.90326 6.75 6.33097 6.51295 5.90901 6.09099C5.48705 5.66903 5.25 5.09674 5.25 4.5C5.25 3.90326 5.48705 3.33097 5.90901 2.90901C6.33097 2.48705 6.90326 2.25 7.5 2.25ZM3.75 1.5C3.75 1.89782 3.59196 2.27936 3.31066 2.56066C3.02936 2.84196 2.64782 3 2.25 3V6C2.64782 6 3.02936 6.15804 3.31066 6.43934C3.59196 6.72064 3.75 7.10218 3.75 7.5H11.25C11.25 7.10218 11.408 6.72064 11.6893 6.43934C11.9706 6.15804 12.3522 6 12.75 6V3C12.3522 3 11.9706 2.84196 11.6893 2.56066C11.408 2.27936 11.25 1.89782 11.25 1.5H3.75Z",
    fill: "#64A4A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/Bill.9d9c611e1af1dd40d0cf30030ddd2a18.svg";
export { ForwardRef as ReactComponent };